export enum ProductId {
  healthBasic = "health_basic",
  healthUnlimited = "health_unlimited",
  glExtended = "gl_extended",
  prevention = "prevention",
}

export enum HealthProductAlias {
  healthBasic = "barkibu 80",
}
